import React, { Fragment, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { createReview } from '../../../common/api';
import { toast } from 'react-toastify';
import { formatDate } from '../../../common/utils';
import Rating from '@mui/material/Rating';

import '../modals.css';

const AddReview = ( { close, aid, uid, obj, objType } ) => {
    const [ teaser, setTeaser ] = useState();
    const [ review, setReview ] = useState();
    const [ requestDate, setRequestDate ] = useState();
    const [ reviewDate, setReviewDate ] = useState();
    const [ rating, setRating ] = useState( 0 );
    const [ url, setUrl ] = useState();
    const [ ready, setReady ] = useState( false );
    const [ showReqDate, setShowReqDate ] = useState( false );
    const [ processing, setProcessing ] = useState( false );

    useEffect( () => {
        if ( teaser && teaser.length > 0 ) {
            setReady( true );
        } else {
            setReady( false );
        }
    }, [ teaser ] );

    useEffect( () => {
        const today = new Date();
        setReviewDate( formatDate( today ) );
    }, [] );

    const create = async () => {
        setProcessing( true );

        const r = {
            aid: obj.details.aid,
            uid: uid,
            headline: teaser,
            review: review,
            rating: rating,
            maxRating: 5,
            status: 'Completed',
            url: url,
            reviewDate: reviewDate,
            requestDate: requestDate
        };
        
        const contacts = [];
        let lid;

        if ( objType === 'contact' ) {
            contacts.push( obj.details.cid );
        } else if ( objType === 'loan' ) {
            lid = obj.details.lid;
            obj.borrowers?.forEach( b => contacts.push( b.cid ) );
        }

        const added = await createReview( obj.details.aid, uid, r, contacts, lid );
        if ( added.length ) {
            toast.success( `Review has been saved`, { theme: 'dark' } );
            close();
        }
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '450px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Record a Client Review</Col>
                </Row>
                {
                    processing ? (
                        <Fragment>
                            <Row className='py-3'>
                                <Col className='text-center'>
                                    <Spinner animation="border" variant='primary' role="status" />
                                </Col>
                            </Row>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Row className='py-3'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Did you request this review?</Form.Label>
                                        <Form.Check type='switch' id='req-switch' label='Yes' onChange={ ( e ) => setShowReqDate( !showReqDate ) } />
                                    </Form.Group>
                                </Col>
                                {
                                    showReqDate ? (
                                        <Col xs='auto'>
                                            <Form.Group>
                                                <Form.Label>Date requested</Form.Label>
                                                <Form.Control className='tf-modal-text-input' type="date" value={requestDate} onChange={ ( e ) => setRequestDate( e.target.value ) } />
                                            </Form.Group>
                                        </Col>
                                    ) : (
                                        <Fragment />
                                    )
                                }
                            </Row>
                            <Row className='py-3'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Date of this review</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type="date" value={reviewDate} onChange={ ( e ) => setReviewDate( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-3'>
                                <Col xs='auto'>
                                    <div><Form.Label>The star rating they provided</Form.Label></div>
                                    {/* <div><Rating onClick={handleRating} ratingValue={rating} size={25} /></div> */}
                                    <div><Rating onChange={ ( e, v ) => setRating( v ) } value={rating} precision={0.5} /></div>
                                </Col>
                            </Row>
                            <Row className='py-3'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Enter a brief headline/teaser quote from the review</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type="text" placeholder="Enter a Headline Quote" value={teaser} onChange={ ( e ) => setTeaser( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-3'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Enter the Entire Review</Form.Label>
                                        <Form.Control className='tf-modal-text-input' as="textarea" rows={3} placeholder="Entire review goes here..." value={review} onChange={ ( e ) => setReview( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-3'>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>URL to the review (assuming it's online somewhere...)</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type="text" placeholder="URL" value={url} onChange={ ( e ) => setUrl( e.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-3'>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => create() } disabled={!ready}>Create</Button>
                                </Col>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                                </Col>
                            </Row>
                        </Fragment>
                    )
                }
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadGroups,
} );
  
export default connect( mapProps, mapDispatch )( AddReview );